import { PermissionList } from "@/libs/defaultList";
export default [
  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*

  {
    path: "/reports/sales",
    name: "reports-sales",
    component: () => import("@/views/reports/sales/main.vue"),
    meta: {
      pageTitle: "Sales Reports",
      breadcrumb: [
        {
          text: "Sales Reports",
          active: true,
        },
      ],
      permission: PermissionList.Sales_View,
    },
  },

  {
    path: "/reports/inventory",
    name: "reports-inventory",
    component: () => import("@/views/reports/inventory/main.vue"),
    meta: {
      pageTitle: "Inventory Reports",
      breadcrumb: [
        {
          text: "Inventory Reports",
          active: true,
        },
      ],
      permission: PermissionList.Inventory_View,
    },
  },

  {
    path: "/reports/marketing",
    name: "reports-marketing",
    component: () => import("@/views/reports/marketing/main.vue"),
    meta: {
      pageTitle: "Marketing Reports",
      breadcrumb: [
        {
          text: "Marketing Reports",
          active: true,
        },
      ],
      permission: PermissionList.Marketing_View,
    },
  },

  {
    path: "/reports/production",
    name: "reports-production",
    component: () => import("@/views/reports/production/main.vue"),
    meta: {
      pageTitle: "Production Reports",
      breadcrumb: [
        {
          text: "Production Reports",
          active: true,
        },
      ],
      permission: PermissionList.Production_View,
    },
  },
  {
    path: "/reports/accounting/trial",
    name: "reports-acc-trial",
    component: () =>
      import("@/views/reports/accountingreport/TrialBalanceReport.vue"),
    meta: {
      pageTitle: "Trial Balance Report",
      breadcrumb: [
        {
          text: "Accounting Reports",
          to: "/accountingreports",
        },
        {
          text: "Trial Balance",
          active: true,
        },
      ],
      permission: PermissionList.Accounting_View,
    },
  },
  {
    path: "/reports/accounting/balancesheet",
    name: "reports-acc-bal",
    component: () =>
      import("@/views/reports/accountingreport/BalanceSheetReport.vue"),
    meta: {
      pageTitle: "Balance Sheet Report",
      breadcrumb: [
        {
          text: "Accounting Reports",
          to: "/accountingreports",
        },
        {
          text: "Balance Sheet",
          active: true,
        },
      ],
      permission: PermissionList.Accounting_View,
    },
  },
  {
    path: "/reports/accounting/pnl",
    name: "reports-acc-pnl",
    component: () => import("@/views/reports/accountingreport/PandLReport.vue"),
    meta: {
      pageTitle: "Profit & Loss Report",
      breadcrumb: [
        {
          text: "Accounting Reports",
          to: "/accountingreports",
        },
        {
          text: "Profit & Loss",
          active: true,
        },
      ],
      permission: PermissionList.Accounting_View,
    },
  },
  {
    path: "/reports/accounting/tds",
    name: "reports-acc-tds",
    component: () => import("@/views/reports/accountingreport/TDS.vue"),
    meta: {
      pageTitle: "Tax Deducted at Source",
      breadcrumb: [
        {
          text: "Accounting Reports",
          to: "/accountingreports",
        },
        {
          text: "Tax Deducted at Source",
          active: true,
        },
      ],
      permission: PermissionList.Accounting_View,
    },
  },
  {
    path: "/reports/accounting/cashbook",
    name: "reports-acc-cashbook",
    component: () => import("@/views/reports/accountingreport/Cashbook.vue"),
    meta: {
      pageTitle: "Cash Book",
      breadcrumb: [
        {
          text: "Accounting Reports",
          to: "/accountingreports",
        },
        {
          text: "Cash Book",
          active: true,
        },
      ],
      permission: PermissionList.Accounting_View,
    },
  },
  {
    path: "/reports/accounting/VATReturn",
    name: "reports-acc-VATReturn",
    component: () => import("@/views/reports/accountingreport/VATReturn.vue"),
    meta: {
      pageTitle: "VAT Report",
      breadcrumb: [
        {
          text: "Accounting Reports",
          to: "/accountingreports",
        },
        {
          text: "VAT Report",
          active: true,
        },
      ],
      permission: PermissionList.Accounting_View,
    },
  },
  {
    path: "/reports/accounting/GeneralLedger",
    name: "reports-acc-GeneralLedger",
    component: () => import("@/views/reports/accountingreport/GeneralLedger.vue"),
    meta: {
      pageTitle: "General Ledger",
      breadcrumb: [
        {
          text: "Accounting Reports",
          to: "/accountingreports",
        },
        {
          text: "General Ledger",
          active: true,
        },
      ],
      permission: PermissionList.Accounting_View,
    },
  },
  {
    path: "/reports/project",
    name: "reports-project",
    component: () => import("@/views/reports/project/main.vue"),
    meta: {
      pageTitle: "Project",
      breadcrumb: [
       
     
        {
          text: "Project Report",
          active: true,
        },
      ],
     
    },
  },
];
